import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Brand logo (full lockup) + 3D imagery
export const LOGO_URL = "/logo.png";
export const EMBLEM_3D = "/emblem.png";
export const NODE_SPHERE_3D =
  "https://static.prod-images.emergentagent.com/jobs/74ec4b1a-5c4a-4875-939e-b55be3ef816b/images/9bb39f2fb7a7a0bbd4f1671a081066aade25a6229099b6d702707bc7cc3e121e.png";
export const GOLD_STAR_3D =
  "https://static.prod-images.emergentagent.com/jobs/74ec4b1a-5c4a-4875-939e-b55be3ef816b/images/627f701909e864bb4f8c945481635789c39d5ac7e90a8d6231cb5227474cbabd.png";
export const BAH_FLAG =
  "https://static.prod-images.emergentagent.com/jobs/74ec4b1a-5c4a-4875-939e-b55be3ef816b/images/8a15aa4200dd9f4bb9e6f74ea7e1c71bce4e51814879db24b0481f4a957cf15c.png";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
